export enum GlobalActionType {
  UpdateFlowStep = 'UpdateFlowStep',
  UpdateAmazonId = 'UpdateAmazonId',
  UpdateGetNotified = 'UpdateGetNotified',
}

export enum FlowStep {
  compatibilityChecker = 'compatibilityChecker',
  notCompatible = 'notCompatible',
  success = 'success',
  infoNeeded = 'infoNeeded',
}

export type GlobalStore = {
  flowStep: FlowStep;
  amazonId: string;
  getNotified: Set<string>;
};

export const defaultGlobalStore: GlobalStore = {
  flowStep: FlowStep['compatibilityChecker'],
  amazonId: '',
  getNotified: new Set<string>(),
};
